import React, { useState, useEffect } from 'react';
import CommonModal from '../common/commonModal/CommonModal';
import { companyCrud } from '../../api/company';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import validateFields from '../ValidationChecker';

const CompanyModal = ({ show, onHide, initialData, onSaveSuccess }) => {
    const [modalMode, setModalMode] = useState('add');
    const [modalData, setModalData] = useState({ sheet_company_name: '', identifier_code: '' });
    const [initialModalState, setInitialModalState] = useState({ sheet_company_name: '', identifier_code: '' });
    const [errors, setErrors] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    // These columns define the fields in the modal's form
    const columns = [
        { header: 'Company Name', accessor: 'sheet_company_name', type: 'text', required: true },
        { header: 'Identifier Code', accessor: 'identifier_code', type: 'text', required: true },
    ];

    useEffect(() => {
        if (show) {
            // If initialData is provided, we are in 'edit' mode
            if (initialData && initialData.id) {
                setModalMode('edit');
                const data = {
                    id: initialData.id,
                    sheet_company_name: initialData.sheet_company_name || '',
                    identifier_code: initialData.identifier_code || '',
                };
                setModalData(data);
                setInitialModalState(data);
            } else {
                // Otherwise, we are in 'add' mode
                setModalMode('add');
                const emptyData = { sheet_company_name: '', identifier_code: '' };
                setModalData(emptyData);
                setInitialModalState(emptyData);
            }
            // Reset state for the new modal instance
            setErrors({});
            setIsChanged(false);
        }
    }, [show, initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setModalData((prev) => {
            const updated = { ...prev, [name]: value };
            // Check if the form data has changed from its initial state
            setIsChanged(JSON.stringify(updated) !== JSON.stringify(initialModalState));
            return updated;
        });
    };

    const handleSave = () => {
        // The `validateFields` function needs the fields definition, which we get from `columns`
        const validationFields = columns.map(c => ({ name: c.accessor, required: c.required }));
        const { isValid, errors: validationErrors } = validateFields(modalData, validationFields);

        if (isValid) {
            setIsSaving(true);
            const method = modalMode === 'add' ? 'post' : 'put';

            companyCrud(modalData, method, (res) => {
                setIsSaving(false);
                if (res?.status === true || res?.status === 200) {
                    ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                    if (onSaveSuccess) {
                        onSaveSuccess(); // Trigger the callback to refresh data in the parent
                    }
                    onHide(); // Close the modal
                } else {
                    if (res?.data?.errors) {
                        setErrors(res?.data?.errors);
                    } else {
                        ReactNotifications(res?.data?.message || 'An error occurred', utilConstants.getErrorStatus);
                    }
                }
            });
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <CommonModal
            show={show}
            handleClose={onHide}
            handleSave={handleSave}
            mode={modalMode}
            columns={columns}
            data={modalData}
            handleChange={handleChange}
            errors={errors}
            isChanged={isChanged}
            isSaving={isSaving}
        />
    );
};

export default CompanyModal;
